@if (print && filter) {
  <app-print-filter-data [filter]="filter"/>
}
@if (data) {

  @for (incentive of data; track $index) {

    <div class="card">
      <div class="card__header">
        <div>
          <p class="title">{{ incentive.title }}</p>
          <p class="description">{{ incentive.branchName }}</p>
        </div>
      </div>

      <div class="card__wrapper">
        <div class="card__box">
          <p>Data de vigência</p>
          <h4>{{ incentive.startDate | date:'dd/MM/yyyy' }}
            - {{ incentive.endDate | date:'dd/MM/yyyy' }}</h4>
        </div>

        <div class="card__box">
          <p> Quantidade entregue</p>
          <h4>{{ incentive.totalOfDrawsDelivered }}/{{ incentive.totalOfDrawsInPeriod }}</h4>
        </div>

      </div>

      <div class="card__winner-table">
        <div class="card__winner-table__row card__winner-table__row--header">
          <div class="card__winner-table__header">Momento do sorteio</div>
          <div class="card__winner-table__header">Momento da pesquisa</div>
          <div class="card__winner-table__header">Momento da entrega</div>
          <div class="card__winner-table__header">Ganhador</div>
          <div class="card__winner-table__header">Nome do ganhador</div>
          <div class="card__winner-table__header">Ações</div>
        </div>

        @for (winner of drawDataPagination(incentive.id); track winner.id) {
          <div class="card__winner-table__row">
            <div class="card__winner-table__cell">
              {{ winner.dateTimeDraw | date : "dd/MM/yyyy 'às' HH:mm" }}
            </div>

            <div class="card__winner-table__cell" [class.center]="!winner.drawn"
            >{{ !winner.dateTimePollSubmission ? '-' : winner.dateTimePollSubmission | date : "dd/MM/yyyy 'às' HH:mm" }}
            </div>

            <div class="card__winner-table__cell" [class.center]="!winner.dateTimeDelivery"
            >{{ !winner.dateTimeDelivery ? '-' : winner.dateTimeDelivery | date : "dd/MM/yyyy 'às' HH:mm" }}
            </div>

            <div class="card__winner-table__cell">{{ winner.winner }}</div>
            @if (print) {
              <div class="card__winner-table__cell" [class.center]="!winner.winnerName">{{ winner?.winnerName ?? '-' }}
              </div>
              <div class="card__winner-table__cell card__winner-table__cell--not-padding">
                <div class="btn-only-print"
                     [class.btn-only-print--delivered]="winner.delivered">
                  {{ winner.delivered ? 'Entregue' : '-' }}
                </div>
              </div>
            } @else {
              <div class="card__winner-table__cell card__winner-table__cell--not-padding">
                <input
                  class="card__winner-table__input"
                  matInput
                  maxlength="100"
                  placeholder="Digite aqui..."
                  [disabled]="winner.delivered || isIncentiveExpired(incentive.endDate)"
                  [(ngModel)]=" winner.winnerName"
                />
              </div>
              <div class="card__winner-table__cell card__winner-table__cell--not-padding">
                @if (winner.delivered) {
                  <button class="card__winner-table__button card__winner-table__button--delivered">Entregue
                  </button>
                } @else {
                  <button class="card__winner-table__button"
                          (click)="winnerDelivery(winner)"
                          [disabled]="isIncentiveExpired(incentive.endDate)"
                          [style.opacity]="isIncentiveExpired(incentive.endDate) ? '0.5' : '1'"
                          [style.cursor]="isIncentiveExpired(incentive.endDate) ? 'not-allowed' : 'pointer'">
                          Entregar
                  </button>
                }
              </div>
            }
          </div>
        }
        @if (incentive.draws.length >= 0 && !print) {
          <app-pagination
            [total]="incentive.draws.length"
            [value]="incentive.pagination"
            [showRowsSelect]="true"
            (onPaginationChange)="onPaginationChange($event, incentive)"
          />
        }
      </div>


    </div>
  }
}
